var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Live = OCS.WxBriefing.Live || {};
OCS.WxBriefing.Functions = OCS.WxBriefing.Functions || {};

OCS.WxBriefing.Classes.ProductManager = new Class({
    Implements: [OCS.WxBriefing.Classes.SingletonManager],
    manager_name: 'ProductManager',
    events: {},
    products: {},
    options: {
        product_fetched_event: 'product_fetched',
        max_failed_attempts: 3
    },
    init: function (op) {
        this.setOptions(op);
        OCS.console.debug_text('OCS.WxBriefing.Live.UI.ProductManager initialized');


        OCS.Functions.get_ajax_manager();
    },

    fetch_product: function (in_entry_id) {
        var am = OCS.Functions.get_ajax_manager();
        var entry_id;
        if (OCS.Utilities.is_object(in_entry_id)) {
            entry_id = in_entry_id.entry_id;
        } else {
            entry_id = in_entry_id;
        }
        if (this.is_product_fetched(entry_id)) {
            return this.products[entry_id].response;
        }

        var req = am.request("fetch_product-" + entry_id, {
            url: '/index.php/api/weather_briefing/product/format/json/entry_id/' + entry_id,
            dataType: "json",
            method: "GET",
            onSuccess: this.on_fetch_product_success.bind(this),
            onFailure: this.on_fetch_product_failure.bind(this)

        });
        req.send();

    },
    product_fetched: function (data) {
        this.fireEvent(this.options.product_fetched_event, data);
    },
    on_fetch_product_success: function (response) {
        var data = new OCS.WxBriefing.Classes.Product(response.json);
        data.set_retrieved(true);
        this.products[data.options.entry_id] = {response: data, retrieved: true};
        this.product_fetched(data);
    },
    on_fetch_product_failure: function (response) {
        console.warn("product request fail", response);
        if (response.failed_attempts < this.options.max_failed_attempts) {
            response.request.send();
        } else {
            console.warn("Unable to retrieve product. Giving up after " + response.failed_attempts + " failed attempts.");
        }
    },
    is_product_fetched: function (entry_id) {
        return this.products.hasOwnProperty(entry_id) && this.products[entry_id].response.retrieved;
    },
    get_product_by_entry_id: function (entry_id) {
        if (!this.is_product_fetched(entry_id)) {
            var data = new OCS.WxBriefing.Classes.Product($('[data-entry_id=' + entry_id + ']').data());
            this.products[entry_id] = {response: data, retrieved: false};
        }
        return this.products[entry_id].response;
    },
    get_product_ga_label: function (entry_id) {
        var product_data = this.get_product_by_entry_id(entry_id);
        if (product_data) {
            return entry_id + ' - ' + product_data.title;
        }
    },
    get_product_type: function (entry_id) {
        var product_data = this.get_product_by_entry_id(entry_id);
        if (product_data) {
            return product_data.get_product_type();
        }
    },
    clear_data: function () {
        this.products = {};
    },
    destroy: function () {
        this.clear_data();
    }

});